import { Environment } from 'Common/environment/types'

export type AuthMode = 'legacy' | 'sid'

const LEGACY_CLIENT_ID = 'opus'
const DEFAULT_SID_CLIENT_ID = 'ui-client'
const LEGACY_SCOPE = 'openid profile opus opus_info'
const DEFAULT_SID_SCOPE = 'openid profile opus opus_info mockingbird offline_access'

export type ResolvedIdentityConfig = {
    mode: AuthMode
    authority: string
    clientId: string
    scope: string
    customerHint?: string
}

export function resolveIdentityConfig(environment: Environment): ResolvedIdentityConfig {
    const { identity, identityserver, customerHint } = environment.endpoints

    if (identity) {
        return {
            mode: 'sid',
            authority: identity,
            clientId: import.meta.env.VITE_OIDC_CLIENT_ID ?? DEFAULT_SID_CLIENT_ID,
            scope: import.meta.env.VITE_OIDC_SCOPE ?? DEFAULT_SID_SCOPE,
            customerHint:
                import.meta.env.VITE_CUSTOMER_HINT ?? customerHint ?? environment.settings.customer,
        }
    }

    return {
        mode: 'legacy',
        authority: identityserver ?? '',
        clientId: LEGACY_CLIENT_ID,
        scope: LEGACY_SCOPE,
    }
}
